// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LoginHero-module__root--SKHL6 {
  text-align: center;
}

.LoginHero-module__title--VzK7O,
.LoginHero-module__description--YkTir {
  margin: 0;
}

.LoginHero-module__title--VzK7O {
  color: #fcfaf7;
  font-size: 32px;
  font-weight: 600;
  line-height: 40px;
}

.LoginHero-module__description--YkTir {
  margin-top: 12px;
  color: #bdbdbd;
  font-size: 16px;
  line-height: 24px;
}

.LoginHero-module__reverse--pVDlS .LoginHero-module__title--VzK7O {
  color: #1a1a1a;
}

.LoginHero-module__reverse--pVDlS .LoginHero-module__description--YkTir {
  color: #666;
}
`, "",{"version":3,"sources":["webpack://./src/pages/LoginPage/components/LoginHero/LoginHero.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb","sourcesContent":[".root {\n  text-align: center;\n}\n\n.title,\n.description {\n  margin: 0;\n}\n\n.title {\n  color: #fcfaf7;\n  font-size: 32px;\n  font-weight: 600;\n  line-height: 40px;\n}\n\n.description {\n  margin-top: 12px;\n  color: #bdbdbd;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n.reverse .title {\n  color: #1a1a1a;\n}\n\n.reverse .description {\n  color: #666;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `LoginHero-module__root--SKHL6`,
	"title": `LoginHero-module__title--VzK7O`,
	"description": `LoginHero-module__description--YkTir`,
	"reverse": `LoginHero-module__reverse--pVDlS`
};
export default ___CSS_LOADER_EXPORT___;
